import * as React from "react";
import "./optionSelector.scss";

export interface SelectableOption {
	/**
	 * Option value
	 */
	value: any;
}

interface IProps {
	selectedOption?: string
	/**
	 * Selectable options
	 */
	selectableOptions: SelectableOption[];
	/**
	 * On select callback
	 * @param {any} selectedOptionValue
	 * @returns {any}
	 */
	onSelect: (selectedOptionValue: any) => any;
	/**
	 * Indicates if component is disabled
	 */
	disabled?: boolean;
}

interface IState {
	/**
	 * Selected option value
	 */
	selectedOptionValue: any
}

export default class OptionSelector extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {selectedOptionValue: null};
		this.onSelect = this.onSelect.bind(this);
		this.renderOption = this.renderOption.bind(this);
	}

	render() {
		return (
			<div className={"m-selector_wrapper"}>
				<select onChange={this.onSelect} disabled={this.props.disabled} value={this.props.selectedOption}>
					{this.props.selectableOptions.map((option, index) => this.renderOption(option, index))}
				</select>
			</div>
		);
	}

	/**
	 * On select callback
	 * @param {any} optionValue
	 */
	onSelect(optionValue: any) {
		this.setState({selectedOptionValue: optionValue.target.value}, () => {
			if (this.props.onSelect !== null && this.props.onSelect !== undefined) {
				this.props.onSelect(this.state.selectedOptionValue);
			}
		});
	}

	/**
	 * Renders single option
	 * @param {SelectableOption} option
	 * @param {number} index
	 * @returns {JSX.Element}
	 */
	renderOption(option: SelectableOption, index: number): JSX.Element {
		return (
			<option key={index} value={option.value}>{option.value}</option>
		);
	}
}